import * as React from 'react';
import HashTrigger from '@telia-front/hash-trigger';
import PropsChecker from '@telia-front/props-checker';
export const LightboxContext = React.createContext({
    id: '',
    isOpen: false,
    open: /* istanbul ignore next */ () => null,
    close: /* istanbul ignore next */ () => null,
    triggerRef: /* istanbul ignore next */ () => null,
});
const LightboxProvider = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "LightboxProvider", defaultValueName: "defaultIsOpen", valueName: "isOpen", onChangeNames: "onToggle" },
        React.createElement(LightboxProviderInner, Object.assign({}, props))));
};
export default LightboxProvider;
const LightboxProviderInner = (props) => {
    const { children, id, onClose, onOpen, onToggle } = props;
    const [isOpen, setIsOpen] = React.useState(props.defaultIsOpen || false);
    const isOpenControlled = (prop = props.isOpen) => !!(onToggle && typeof prop !== 'undefined');
    const currentOpen = isOpenControlled(props.isOpen) ? props.isOpen : isOpen;
    const [trigger, setTrigger] = React.useState(null);
    const open = () => {
        if (!isOpenControlled()) {
            setIsOpen(true);
        }
        if (onOpen) {
            onOpen();
        }
        if (onToggle) {
            onToggle(true);
        }
    };
    const close = () => {
        if (!isOpenControlled()) {
            setIsOpen(false);
        }
        if (onClose) {
            onClose();
        }
        if (onToggle) {
            onToggle(false);
        }
        setTimeout(() => {
            trigger === null || trigger === void 0 ? void 0 : trigger.focus();
        }, 200);
    };
    const contextValue = {
        isOpen: currentOpen,
        open: open,
        close: close,
        id: id,
        triggerRef: setTrigger,
    };
    return (React.createElement(LightboxContext.Provider, { value: contextValue },
        React.createElement(HashTrigger, { id: id, onMatch: open, scrollOnMatch: false, renderWrapper: false }, children)));
};
